var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "card-content" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Nombre de unidad compuesta"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nombre,
                expression: "nombre",
              },
            ],
            staticClass: "input",
            attrs: {
              type: "text",
              name: "Nombre de unidad compuesta",
              "data-vv-scope": "crear-unidad-compuesta",
            },
            domProps: { value: _vm.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.nombre = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.errors.has("Nombre de unidad compuesta", "crear-unidad-compuesta")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(
                  _vm._s(
                    _vm.errors.first(
                      "Nombre de unidad compuesta",
                      "crear-unidad-compuesta"
                    )
                  )
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Serie documental de la unidad compuesta"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("div", { staticClass: "select is-fullwidth" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.serie_documental_id,
                    expression: "serie_documental_id",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                attrs: {
                  name: "Serie",
                  "data-vv-scope": "crear-unidad-compuesta",
                },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.serie_documental_id = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "" }, domProps: { value: null } },
                  [_vm._v("- Seleccione una serie documental -")]
                ),
                _vm._v(" "),
                _vm._l(_vm.seriesDocumentales, function (serie, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: serie.id } },
                    [_vm._v(_vm._s(serie.nombre))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.errors.has("Serie", "crear-unidad-compuesta")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(
                  _vm._s(_vm.errors.first("Serie", "crear-unidad-compuesta"))
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("Heredar permisos")]),
        _vm._v(" "),
        _vm.forceHerencia
          ? _c("p", { staticClass: "is-size-7 has-text-primary mb-3" }, [
              _c("i", { staticClass: "fas fa-exclamation-triangle" }),
              _vm._v(" "),
              _c("b", [_vm._v("Nota:")]),
              _vm._v(
                " Los documentos y carpetas de la carpeta " +
                  _vm._s(_vm.currentFolder.name) +
                  " heredarán los permisos por defecto"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c(
              "b-switch",
              {
                attrs: { size: "is-small", disabled: _vm.forceHerencia },
                model: {
                  value: _vm.permisos,
                  callback: function ($$v) {
                    _vm.permisos = $$v
                  },
                  expression: "permisos",
                },
              },
              [_vm._v("Heredar permisos de la carpeta superior")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("footer", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "card-footer-item has-text-weight-bold is-uppercase",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [_vm._v("Crear")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Crear unidad compuesta"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }